export default __webpack_public_path__ + "assets/denmark-flag.png";